import { render, staticRenderFns } from "./SettingsSms.vue?vue&type=template&id=7f539ad4&scoped=true&"
import script from "./SettingsSms.vue?vue&type=script&lang=js&"
export * from "./SettingsSms.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSms.vue?vue&type=style&index=0&id=7f539ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f539ad4",
  null
  
)

export default component.exports